import React, { Component } from 'react';
import config from "../app/Config";

const propTypes = {
};

const defaultProps = {
};

class IsUp extends Component {
	constructor(props) {
		super(props);

		this.state = {
			okay: false,
			error: 'An error occurred',
		};

	}

	render() {
		return (
			<div>
				<p>{this.state.okay?'up':'down'}</p>
				<p>{this.state.error}</p>
			</div>
		);
	}

	componentDidMount() {
		fetch(config.baseWebserviceUrl + 'offer/get/isUp')
			.then(response => response.json())
			.then(data => this.setState({ okay: data.okay, error: data.error }))
			.catch(console.log);
	}
}

IsUp.propTypes = propTypes;
IsUp.defaultProps = defaultProps;

export default IsUp;